<script>
    const host = `${process.env.VUE_APP_API_URL}`;
    export default {
        name: "ApiRouter",
        data: function () {
            return {
                routes :{
                    articles: host + '/api/v1/articles',
                    article: function (id) {
                        return host + '/api/v1/articles/' + id;
                    },
                    downloadArticles: function (id) {
                        return host + '/api/v1/articles/' + id + '/download';
                    },
                    questionnaire: host + '/api/v1/questionnaire',
                    cookie : host + '/api/v1/cookie',
                }
            }
        }
    }
</script>
